// Vendor imports
const { createSelector } = require('reselect')

const getCurrentModalSlide = createSelector(
  state => state.articleProfileModal,
  articleProfileModal => {
    if (articleProfileModal) {
      return articleProfileModal.slides.get(articleProfileModal.currentIndex)
    }
  }
)

function getSlide(state, props) {
  if (state.articleProfileModal && props.slideIndex != null) {
    // Extract item from ArticleProfileModalRecord
    return state.articleProfileModal.slides.get(props.slideIndex)
  }
  return state.articleProfile
}

function makeSlideRelatedSelectors() {
  function getSlideRelatedStream(state, props) {
    return getSlide(state, props).relatedStream
  }

  // Memoize to prevent unnecessary updates
  // https://github.com/reduxjs/reselect#motivation-for-memoized-selectors
  const getSlideRelatedDenormalizedItems = createSelector(
    getSlideRelatedStream,
    stream => stream && stream.getDenormalizedItems({
      pageName: 'article.card',
      referrerPageSection: 'related-articles'
    })
  )

  return {
    getSlideRelatedDenormalizedItems,
    getSlideRelatedStream
  }
}



module.exports = {
  getCurrentModalSlide,
  getSlide,
  makeSlideRelatedSelectors
}
